import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalService } from '../../services/config/global/global.service';
import { Token } from '../../interfaces/token';
import { DatosTitular } from '../../interfaces/datos-titular';

@Injectable({
  providedIn: 'root'
})
export class PasswordService {
  token: any;
  urlApi: string;
  
  constructor(private http: HttpClient, private _globalService: GlobalService) {
    // Direccion url API
    this.urlApi = this._globalService.getUrlApi();
    this.token = localStorage.getItem('token');
  }

  getLogin(u, p): Observable<Token> {
    const httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: this.token });
    const options = { headers: httpHeaders };
    const body = { usuario: u, password: p };
    return this.http.post<Token>(this.urlApi + 'Login/DatosTitular', body, options);
  }

  getCambioPassword(idCliente, passNueva, token): Observable<Token> {
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token
    });
    const options = {
      headers: httpHeaders
    };
    const body = {
      IdCliente: idCliente,
      PassNueva: passNueva,
      isAdmin: localStorage.getItem('IsAdministrador') == 'true' ? true : false
    };
    return this.http.post<Token>(this.urlApi + 'Modificacion/ModificarPassword', body, options);
  }

  getRecuperarPassword(identificador){
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = {
      headers: httpHeaders
    };
    const body = {
      Identificador: identificador
    };
    return this.http.post(this.urlApi + 'Modificacion/RecuperarPassword', body, options);
  }

  getRecuperarPasswordMarca(identificador, marca){
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = {
      headers: httpHeaders
    };
    const body = {
      Identificador: identificador,
      Marca: marca
    };
    return this.http.post(this.urlApi + 'Modificacion/RecuperarPasswordMarca', body, options);
  }

}
